import '../css/Footer.css'

const Footer = ({information, text, lang}) => {
    const handleClickLanding = () => {
        const path = window.location.pathname;
        const parts = path.split('/').filter(Boolean);

        const lang = parts[0];
        const isBorjomiPage = parts.includes('bike-rental-borjomi');

        if (isBorjomiPage) {
            window.location.reload();
            return;
        }

        window.location.href = `/${lang}/bike-rental-borjomi`;
    };
    return (
        <div className="footer" id="footer">
            <div>
                <div>B.RIDE.VOLT</div>
                <div>B.R.V</div>
                <div className='landing_link' onClick={handleClickLanding}>{text['premium_e_bike_rentals']?.[lang]}</div>
            </div>
            <div>
                <div>{text['contact']?.[lang]}</div>
                <a rel="noreferrer" target="_blank" data-id="phone_white" href={`tel:${information["call_number"]}`}>{information["call_number"]}</a>
                <a target="_blank" data-id="whatsapp_white" href={`https://wa.me/${information["whatsapp_number"]}`} rel="noopener noreferrer">{`+${information["whatsapp_number"]}`}</a>
                <a rel="noreferrer" target="_blank" data-id="telegram_white" href={`https://t.me/${information["telegram_username"]}`}>@{information["telegram_username"]}</a>
                <a data-id="email_white" href={`mailto:${information['email']}?subject=Renting%20a%20e-bike`}>{information['email']}</a>
                <a rel="noreferrer" target="_blank" data-id="kamoot_white" href={information['kamoot']}>Komoot</a>
                <a rel="noreferrer" target="_blank" data-id="instagram_white" href={information['instagram']}>Instagram B.R.V.</a>
            </div>
            <div>
                <div>{text['locations']?.[lang]}</div>
                <a rel="noreferrer" target="_blank" href="https://goo.gl/maps/8Rq6aDCEJLVSbjs29?g_st=aw">
                    <div data-id="location_white">{text['borjomi_georgia']?.[lang]}</div>
                </a>
                <a rel="noreferrer" target="_blank" href="https://maps.app.goo.gl/jQ2pxnPGbvHbeESK9">
                    <div data-id="location_white">{text['bakuriani_georgia']?.[lang]}</div>
                </a>
            </div>
            <div>
                <div>{text['services']?.[lang]}</div>
                <div>{text['e_bike_rental']?.[lang]}</div>
                <div>{text['guided_tours']?.[lang]}</div>
                <div>{text['bike_service']?.[lang]}</div>
                <div>{text['accessories']?.[lang]}</div>
            </div>
            <div>
                <div>{text['operating_hours']?.[lang]}</div>
                <div>{information['open_time']?.[lang]}</div>
            </div>
            <div>{text['all_rights']?.[lang]}</div>
        </div>
    )
}

export default Footer;